<template>
  <ul class="basket-payments-list">
    <li
      v-for="(item, index) in list"
      :key="`basket-payments-list-${index}`"
      class="basket-payments-list__item"
    >
      {{ item }}
    </li>
  </ul>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'PaymentsList',
  setup() {
    return {
      list: [
        'Банковская карта',
        'Наличные',
        'Yandex Pay',
      ],
    };
  },
});
</script>

<style lang="less">
.basket-payments-list {
  .list-reset();

  padding: @size-x3 @size-x4;

  &__item {
    .small();

    margin: 0;

    & + & {
      margin-top: @main-size;
    }
  }
}
</style>
